import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useAuth } from "#/hook/useAuth";
import { UserRole } from "#/types/user";

/** Minimal translate signature the PRV components and helpers need. */
export type PrvT = (key: string, options?: Record<string, unknown>) => string;

/**
 * `t` for the PRV views. Client users never see the word "sub-client" on the
 * platform (their navigation calls those records "Clients"), so for them every
 * key is resolved with the i18next context "client": `key_client` when such a
 * variant exists, the plain key otherwise. TMA admins get the plain keys.
 */
export function usePrvTranslation(): PrvT {
  const { t } = useTranslation();
  const { user } = useAuth();
  const context = user?.role === UserRole.ADMIN ? undefined : "client";

  return useCallback<PrvT>((key, options) => t(key, { ...options, context }), [t, context]);
}
